import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda
} from '../../util/varios';
import { Mensaje } from '../mensajes';
import { Dimmer } from '../spinner';


 
import useTable from "../useTable";
import axios from 'axios';
import { PresupuestoClasificador } from './modalPesupuestoClasificador';


function TablaClasificador(props) {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const headCells = [
        { id: '', label: 'Ramo', width: '30px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
        { id: '', label: 'Gen', width: '30px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
        { id: '', label: 'Espec', width: '30px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
        { id: '', label: 'SubEsp', width: '30px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
        { id: '', label: 'Descripción', width: '200px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
        { id: '', label: 'Monto', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
        { id: '', label: 'OPCIONES', width: '60px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },

    ]

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });



    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);


    const handleCloseMensa = () => {
        setMostrar(false);
        blanquearCampos()
    }


    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }


    const opciones = (ope) => (event) => {

        event.preventDefault();
        blanquearCampos();

        if (ope === 1) {

            setMostrar5(true);
            setOperacion(1);
            blanquearCampos()

        }

    }

    const eliminarPresupuesto = (item) => (e) => {
        e.preventDefault();

        var datos = [...records];
        var elementos = [];
        var blanquea = [];

        for (let i = 0; i < datos.length; i++) {

            if (item.id !== datos[i].id) {
                elementos.push(datos[i]);
            }

        }

        blanquea.push({

            uno: "",
            dos: "",
            tres: "",
            cuatro: "",
            descripcion: "",
            monto: "",
            id: "",
            puc: ""

        });

        setRecords(elementos);
        props.data(elementos);
    }

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);
        let data = [...records];

        console.log(datos)
        for (let i = 0; i < datos.length; i++) {

            data.push({
                uno: datos[i].uno,
                dos: datos[i].dos,
                tres: datos[i].tres,
                cuatro: datos[i].cuatro,
                descripcion: datos[i].descripcion,
                monto: datos[i].monto,
                id: datos[i].id,
                puc: datos[i].puc,
            });

        }

        setRecords(data);
        props.data(data);
    }

    useEffect(() => {

        if (props.datarecords.length > 0) {

            console.log('pase por aqui');
            var data = [...props.datarecords];
            var datos = [];

            for (let i = 0; i < data.length; i++) {

                datos.push({

                    uno: data[i].puc.substring(0, 3),
                    dos: data[i].puc.substring(3, 5),
                    tres: data[i].puc.substring(5, 7),
                    cuatro: data[i].puc.substring(7, 9),
                    descripcion: data[i].descripcion,
                    monto: data[i].disponibilidad,

                });

            }

            console.log(datos);
            setRecords(datos);
        }

    }, [props.datarecords]);

    return (
        <div>

            <PresupuestoClasificador
                modal={props.modal}
                show={mostrar5}
                operacion={operacion}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
            />
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>



            <div className="row col-md-12 mx-auto m-0">

                <div className="col-md-11 m-0 px-0">
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {

                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item} style={{ padding: "0", height: '40px' }}>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "30px" }}>{item.uno}</td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '30px' }}>{item.dos}</td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "30px" }}>{item.tres} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "30px" }}>{item.cuatro} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '200px' }}>{item.descripcion} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '80px' }}>{item.monto} </td>
                                        <td style={{ textAlign: "center", width: '60px' }}>
                                            <button onClick={eliminarPresupuesto(item)} style={{ visibility: (props.operacion === 4 || props.operacion === 2 || props.operacion === 5) && 'collapse' }} disabled={props.operacion === 4 || props.operacion === 5 || props.operacion === 2 ? true : false} className="btn btn-danger btn-sm rounded-circle"><i className="fa fa-trash-alt"></i></button>
                                        </td>


                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    {/* <TblPagination /> */}

                </div>
                <div className='col-md-1 m-auto'>

                    <div className="col-md-12">
                        <button onClick={opciones(1, '')} disabled={props.operacion === 4 || props.operacion === 2 ? true : false} className="btn btn-primary btn-sm rounded-pill"><i className="fas fa-plus"></i> </button>
                    </div>

                </div>
            </div>


        </div>

    );

}

export default TablaClasificador;
